import React from "react";

export default function Base({}) {
	return <>
		<path d="M50 85L56.667 91.667C61.667 96.667 68.334 100 75 100C88.333 100 100 88.333 100 75C100 68.333 96.667 61.667 93.333 56.667L85 50L91.667 43.333C96.667 38.333 100 31.666 100 25C100 11.667 88.333 0 75 0C68.333 0 61.667 3.333 56.667 6.667L50 15L43.333 6.667C38.333 3.333 31.667 0 25 0C11.667 0 0 11.667 0 25C0 31.667 3.333 38.333 6.667 43.333L15 50L6.667 56.667C3.333 61.667 0 68.333 0 75C0 88.333 11.667 100 25 100C31.667 100 38.333 96.667 43.333 93.333L50 85Z"/>
	</>
}